<template>
  <div class="app-wrapper">
    <app-main />
    <heade-bar />
  </div>
</template>

<script>
import { HeadeBar, AppMain } from './components'
export default {
  name: 'layout',
  components: {
    HeadeBar,
    AppMain
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  .top_horizontal_cls{
    position: absolute;
    top: 0;
    z-index: 100;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/index1.vue